export const checkFileType = (
  ext: string,
  imageTypes: string[] = ["jpg", "jpeg", "png", "gif"],
  pdfType: string = "pdf"
) => {
  if (!ext) return "unknown";

  if (imageTypes.includes(ext)) return "image";
  if (ext === pdfType) return "pdf";

  return "other";
};
